/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".risky-scope[_ngcontent-%COMP%]{color:#d2504d}.app-name[_ngcontent-%COMP%]{max-width:100%;display:block;overflow:hidden;word-break:break-all;white-space:nowrap;text-overflow:ellipsis}"];
export { styles as styles };
